<!-- 编辑设备详情弹框 -->
<template>
  <div class="edit-container">
    <el-form
      :model="setForm"
      ref="refForm"
      label-width="120px"
      :key="formKey"
      label-suffix="："
      :rules="pageStates == 'view' ? {} : rules"
    >
      <el-col :span="12">
        <el-form-item label="巡更点名称" prop="pointName">
          <div v-if="pageStates == 'view'">
            {{ setForm.pointName }}
          </div>
          <el-input v-else v-model="setForm.pointName" style="width: 100%"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="打卡方式" prop="punchType">
          <div v-if="pageStates == 'view'">
            {{ typeList[setForm.punchType].label }}
          </div>

          <el-select v-model="setForm.punchType" v-else>
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="巡更点位置" prop="place">
          <div v-if="pageStates == 'view'">
            {{ setForm.place }}
          </div>
          <el-input v-else v-model="setForm.place"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="室内室外" prop="isIndoor">
          <div v-if="pageStates == 'view'">
            {{ setForm.isIndoor == 0 ? "室内" : "室外" }}
          </div>
          <el-radio-group v-model="setForm.isIndoor" v-else>
            <el-radio label="1" border>室外</el-radio>
            <el-radio label="0" border>室内</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>

      <el-col :span="24" v-if="setForm.isIndoor == 0" key="0">
        <el-form-item label="室内位置" prop="buildName">
          <el-input
            v-model="setForm.buildName"
            class="position-set"
            readonly
            placeholder="请标记室内位置"
          ></el-input>
          <el-button
            type="text"
            size="small"
            style="position: absolute; right: 0px; font-size: 18px; top: -3px"
            class="iconfont icon-position choose-person"
            title="选择位置"
            @click="openBuilding"
          ></el-button>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="setForm.isIndoor == 1" key="1">
        <el-form-item label="经度" prop="longitude">
          <div>
            <el-input
              v-model="setForm.longitude"
              class="position-set"
              readonly
              placeholder="请选择位置"
            ></el-input>
            <el-button
              type="text"
              size="small"
              title="选择位置"
              style="position: absolute; right: 0px; font-size: 18px; top: -3px"
              class="iconfont icon-position choose-person"
              @click="openMap"
            ></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="setForm.isIndoor == 1" key="2">
        <el-form-item label="纬度" prop="latitude">
          <div>
            <el-input
              v-model="setForm.latitude"
              class="position-set"
              placeholder="请选择位置"
              readonly
            ></el-input>
            <el-button
              type="text"
              size="small"
              title="选择位置"
              style="position: absolute; right: 0px; font-size: 18px; top: -3px"
              class="iconfont icon-position choose-person"
              @click="openMap"
            ></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <div style="display: flex; align-items: center; margin-bottom: 12px">
          巡更点检查内容
          <i
            v-if="pageStates != 'view'"
            @click="handleAddTable"
            style="font-size: 24px; margin-left: 18px; cursor: pointer"
            class="el-icon-circle-plus-outline"
          ></i>
        </div>
      </el-col>

      <el-col :span="24">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"> </el-table-column>
          <el-table-column prop="content" label="检查内容" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="standards" label="检查标准" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100"
            v-if="pageStates != 'view'"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEditTable(scope.row)"
                >编辑</el-button
              >
              <el-button @click="handleDeleteTable(scope.$index)" type="text" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-form>
    <!-- 引入gis地图 -->
    <el-dialog
      title="室外位置选择"
      width="70%"
      :visible.sync="showMap"
      @close="mapClose"
      :modal="false"
      @click="mapCancelOpt"
    >
      <div id="map-container">
        <AppMap ref="refAppMap" divId="miniMap" />
      </div>
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="mapCancelOpt">取消</el-button>
        <el-button type="primary" @click="mapConfirmOpt" v-if="pageStates != 'view'"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 楼栋树 -->
    <el-dialog
      title="室内位置选择"
      width="70%"
      :visible.sync="showBuilding"
      @close="mapClose"
      :modal="false"
      @click="mapCancelOpt"
    >
      <!--左侧楼栋树-->
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area">
            <div class="tree-container">
              <div class="area-title">楼栋信息</div>
              <div class="area-search">
                <el-input
                  v-model="searchString"
                  clearable
                  placeholder="请输入搜索关键字"
                  prefix-icon="el-icon-search"
                >
                </el-input>
              </div>
              <el-scrollbar class="scroll-bar-view" style="height: 600px">
                <el-tree
                  ref="tree"
                  class="tree-content"
                  :data="treeData"
                  :expand-on-click-node="false"
                  node-key="id"
                  :default-expanded-keys="expandedKeys"
                  :props="treeProps"
                  :highlight-current="true"
                  :filter-node-method="filterNode"
                  @node-click="nodeClick"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <!--右侧展示图纸-->
        <!-- 右侧图纸 -->
        <div class="right-img">
          <div class="canvasMain">
            <div
              class="canvasMainT"
              :style="{
                width: vW + '%',
                height: vH + '%',
                marginTop: getMarginTop + 'px',
                marginLeft: getMarinLeft + 'px',
              }"
            >
              <img
                id="building-img"
                :src="
                  rootDefaultDrawing
                    ? '/images/theme/newDark/default-drawing1.jpg'
                    : imgUrl
                "
              />
              <canvas
                id="mycanvas"
                style="cursor: all-scroll"
                @mousewheel="mouseScroll"
                @DOMMouseScroll="mouseScroll"
                @mousedown="handleDomMoveStart"
                :width="cW"
                :height="cH"
              ></canvas>
            </div>
          </div>
        </div>
        <div class="coord">
          <span> 【 缩放比例 {{ vW }}% 】 </span>
          【相对坐标 X：{{ x }} ，Y：{{ y }} 】
        </div>
      </div>

      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="camCancelOpt">取消</el-button>
        <el-button type="primary" @click="camConfirmOpt" v-if="pageStates != 'view'"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 巡更点检查内容弹窗 -->
    <el-dialog
      title="巡更点检查内容"
      :close-on-click-modal="false"
      width="500px"
      :visible.sync="showTableDialog"
      @close="handleCloseTable"
      :modal="false"
      style="right: 10%"
    >
      <el-form :model="tableForm" ref="refTableForm" :rules="rulesTable">
        <el-form-item label="检查内容" prop="content">
          <el-input
            v-model="tableForm.content"
            placeholder="请输入检查内容"
            type="textarea"
            maxlength="200"
            show-word-limit
            :autosize="{ minRows: 2, maxRows: 6 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="检查标准" prop="standards">
          <el-input
            v-model="tableForm.standards"
            type="textarea"
            maxlength="200"
            show-word-limit
            :autosize="{ minRows: 2, maxRows: 6 }"
            placeholder="请输入检查标准"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseTable">取消</el-button>
        <el-button type="primary" @click="handleSubmitTable">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import { Bus } from "$utils";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
import AppMap from "@src/components/common/gis/index";
export default {
  components: {
    AppMap,
  },
  props: {
    pointsInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    pageStates: {
      type: String,
      default() {
        return "add";
      },
    },
  },

  data() {
    return {
      formKey: 0,
      rules: {
        pointName: [
          {
            required: true,
            message: "请输入巡更点名称",
            trigger: ["blur", "change"],
          },
        ],
        punchType: [
          {
            required: true,
            message: "请选择打卡方式",
            trigger: ["blur", "change"],
          },
        ],
        place: [
          {
            required: true,
            message: "请输入巡更点位置",
            trigger: ["blur", "change"],
          },
        ],
        buildName: [
          {
            required: true,
            message: "请选择室内位置",
            trigger: ["blur", "change"],
          },
        ],
        longitude: [
          {
            required: true,
            message: "请选择室外位置",
            trigger: ["blur", "change"],
          },
        ],
        latitude: [
          {
            required: true,
            message: "请选择室外位置",
            trigger: ["blur", "change"],
          },
        ],
      },
      rulesTable: {
        content: [
          {
            required: true,
            message: "请输入检查内容",
            trigger: "blur",
          },
        ],
        standards: [
          {
            required: true,
            message: "请输入检查标准",
            trigger: "blur",
          },
        ],
      },
      showTableDialog: false,
      tableForm: {
        content: "",
        standards: "",
      },
      tableData: [],
      typeList: [
        {
          label: "GPS",
          value: "0",
        },
        {
          label: "二维码",
          value: "1",
        },
        // {
        //   label: "NFC",
        //   value: "2",
        // },
      ],
      setForm: {
        pointCode: "",
        isIndoor: "1",
        punchType: "0",
        place: "",
        pointName: "",

        longitude: "",
        latitude: "",

        buildingId: "",
        buildName: "",
        floorId: "",
        floorName: "",

        altitude: "",
        width: "",
        fileCode: "",
      },
      isShow: false,
      rootDefaultDrawing: true,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      x: "",
      y: "",
      imgUrl: "",
      showTree: true,
      showBuilding: false,
      treeData: Object.freeze([]),
      searchString: "",
      expandedKeys: [],
      lazyLoad: false,
      cW: 0,
      cH: 0,
      canvasList: [],
      treeDate: [],
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      // 区域树对象
      showMap: false,
      point: {},
      setTimeNum: 0,
      tipImg: {},
      handleClickTime: null,
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  mixins: [deviceMap],
  watch: {
    pointsInfo: {
      handler: function (newVal) {
        if (newVal.buildingId) {
          // 室内
          this.setForm.isIndoor = "0";
        }
        newVal.pointCode ? this.queryResPointInfo(newVal.pointCode) : "";
      },
      immediate: true,
    },
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    searchString: {
      handler(val) {
        this.$refs.tree.filter(val);
      },
    },
    showBuilding(newVal, oldVal) {
      if (oldVal) {
        this.clearCanvas();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.handleClickTime);
    window.onresize = null;
  },
  mounted() {
    this.tipImg[10001] = new Image();
    this.tipImg[10001].src = require("/public/images/theme/newDark/map/pointQr-InActive.png");
  },
  methods: {
    queryResPointInfo(code) {
      this.$fetch(api.queryResPointInfo, {
        pointCode: code,
      }).then((response) => {
        if (response.success) {
          let obj = response.returnObj;
          for (let key in this.setForm) {
            obj[key] ? (this.setForm[key] = obj[key]) : "";
          }
          if (obj.buildingId) {
            // 室内
            this.setForm.isIndoor = "0";
            this.setForm.abscissa = obj.longitude;
            this.setForm.ordinate = obj.latitude;
            this.setForm.longitude = "";
            this.setForm.latitude = "";
            this.setForm.buildName = obj.buildName + "【 " + obj.floorName + " 】 ";
          }

          console.log(this.setForm);
          this.tableData = [...obj.items];
        } else {
          this.$message.error(response.msgContent || "查询失败");
        }
      });
    },
    handleCloseDialog() {
      this.$refs.refForm.resetFields();
      for (let key in this.setForm) {
        if (this.setForm[key]) {
          this.setForm[key] = "";
        }
      }
      this.setForm.punchType = "0";
      this.setForm.isIndoor = "1";
      this.tableData = [];
      this.formKey++;
      console.log(this.setForm);
    },
    subDialog() {
      console.log(this.pageStates);
      this.$refs["refForm"].validate((valid) => {
        if (valid) {
          let params = { ...this.setForm };
          if (params.isIndoor == 0) {
            // 室内
            params.location = "室内";
            params.buildName = params.buildName.split("【")[0];
            params.longitude = params.abscissa;
            params.latitude = params.ordinate;
          } else {
            // 室外
            params.location = "室外";
            params.buildName = "";
            params.buildingId = "";
            params.floorId = "";
            params.floorName = "";
            params.altitude = "";
            params.width = "";
            params.fileCode = "";
          }
          delete params.abscissa;
          delete params.ordinate;

          !params.pointCode && delete params.pointCode;
          params.items = this.tableData.map((el) => {
            return el;
          });
          let url = this.pageStates == "add" ? api.addResPoint : api.updateResPoint;
          console.log(params);
          this.$fetch(url, params).then((response) => {
            if (response.success) {
              this.handleCloseDialog();
              this.$emit("updateTable");
              this.$message.success("操作成功");
            } else {
              this.$message.error(response.msgContent || "操作失败");
            }
          });
        }
      });
    },
    handleSubmitTable() {
      this.$refs["refTableForm"].validate((valid) => {
        if (valid) {
          this.tableData.push({ ...this.tableForm });
          this.handleCloseTable();
        }
      });
    },
    handleCloseTable() {
      this.$refs.refTableForm.resetFields();
      this.showTableDialog = false;
    },
    handleAddTable() {
      this.showTableDialog = true;
    },
    handleEditTable(row) {
      console.log(row);
      for (let key in this.tableForm) {
        this.tableForm[key] = row[key];
      }
      this.showTableDialog = true;
    },
    handleDeleteTable(index) {
      this.tableData.splice(index, 1);
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = [this.setForm.floorId || this.treeData[0].id];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey({
            id: this.setForm.floorId || this.setForm.buildingId,
          });
          setTimeout(() => {
            if (this.setForm.floorId) {
              let checkNode = this.$refs.tree.getCurrentNode();
              console.log(checkNode);
              this.setForm.fileCode = checkNode.fileCode;
              this.imgUrl = this.getImgPath(this.setForm.fileCode);
            }
          }, 0);
        });
      });
    },
    // 打开楼栋选择
    openBuilding() {
      this.showBuilding = true;
      if (this.setForm.buildingId) {
        this.rootDefaultDrawing = false;
      } else {
        this.rootDefaultDrawing = true;
      }
      this.canvasList = [
        {
          abscissa: this.setForm.abscissa,
          ordinate: this.setForm.ordinate,
          width: this.setForm.width,
          height: this.setForm.altitude,
        },
      ];

      this.queryBuildingTree(); //楼栋树
      this.$nextTick(() => {
        this.clickPoints(); //画布添加事件
        this.getCanvasWH(); //回显打点
        let _this = this;
        window.onresize = function () {
          _this.watchScreen();
        };
      });

      console.log(this.canvasList);
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 点击节点
    nodeClick(data) {
      console.log(data);
      // 清空已存在的数据和画布
      if (data.type != 2) {
        this.$message.warning("请将巡更点标记在楼层图纸上");
        return;
        //
      }
      this.clearCanvas();
      this.x = this.y = "";
      // copy选中数据
      // console.log(data.fileCode, "---data");
      if (!data.fileCode) {
        this.rootDefaultDrawing = true;
      } else {
        this.rootDefaultDrawing = false;
        this.setForm.fileCode = data.fileCode;
        this.imgUrl = this.getImgPath(this.setForm.fileCode);
      }
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 画布添加点击事件
    clickPoints() {
      let that = this;
      let x, y;
      var canvas = document.getElementById("mycanvas");
      canvas.addEventListener("click", function (e) {
        clearInterval(that.handleClickTime);
        if (that.setTimeNum < 3) {
          // 超时默认移动事件
          that.showCamImg(e);
          this.setTimeNum = 0;
        }
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          this.setTimeNum = 0;
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
          }
          that.x = x;
          that.y = y;
        },
        false
      );
      canvas.addEventListener(
        "mousedown",
        function (e) {
          that.setTimeNum = 0;
          if (that.handleClickTime) {
            clearInterval(that.handleClickTime);
          }
          that.handleClickTime = setInterval(() => {
            that.setTimeNum++;
          }, 100);
        },
        false
      );
    },
    // 获取canvas father W H
    getCanvasWH() {
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
    },
    // 画布点击回调
    showCamImg(e) {
      this.clearCanvas();
      let x = e.offsetX;
      let y = e.offsetY;
      this.canvasList = [
        {
          abscissa: x,
          ordinate: y,
          width: this.cW,
          height: this.cH,
        },
      ];
      this.x = x;
      this.y = y;
      this.mathCanvas();
    },
    mathCanvas() {
      this.clearCanvas();
      let img = this.tipImg[10001];
      let ctx = this.initCanvas();
      if (this.canvasList.length) {
        this.canvasList.forEach((el) => {
          let wb = this.cW / Number(el.width);
          let hb = this.cH / Number(el.height);
          this.$nextTick(() => {
            ctx.drawImage(
              img,
              Math.round(Number(el.abscissa) * wb - 25),
              Math.round(Number(el.ordinate) * hb - 25),
              50,
              50
            );
          });
        });
      }
    },
    // 画布确定回调
    camConfirmOpt() {
      let checkNode = this.$refs.tree.getCurrentNode();
      if (!checkNode || !checkNode.id || checkNode.type != 2) {
        this.$message.warning("请选择巡更点所属所属楼栋/楼层");
        return;
      }
      if (!this.canvasList.length) {
        this.$message.warning("请在图纸上标记巡更点位");
        return;
      }
      console.log(checkNode);
      this.showBuilding = false;
      this.setForm.buildName = checkNode.parentName + "【 " + checkNode.name + " 】 "; //楼层名称
      // this.setForm.buildName =
      //   checkNode.type == 2 ? checkNode.parentName : checkNode.name; //楼栋名称
      this.setForm.buildingId = checkNode.parentCode; //楼栋id
      this.setForm.floorId = checkNode.id; //楼层id
      this.setForm.floorName = checkNode.name; //楼层名称

      // this.setForm.longitude = this.canvasList[0].abscissa; //x
      // this.setForm.latitude = this.canvasList[0].ordinate; //y

      this.setForm.abscissa = this.canvasList[0].abscissa; //x
      this.setForm.ordinate = this.canvasList[0].ordinate; //y

      this.setForm.width = this.cW; //宽度
      this.setForm.altitude = this.cH; //高度
      // this.setForm.fileCode = this.fileCode;
      this.camCancelOpt();
    },
    camCancelOpt() {
      this.imgUrl = "";
      this.canvasList = [];
      this.showBuilding = false;
      this.rootDefaultDrawing = true;
      this.setTimeNum = 0;
      this.handleClickTime && clearInterval(this.handleClickTime);
      window.onresize = null;
    },
    initMap() {
      this.$refs.refAppMap.getLocation(this.getLocationCB);
      if (this.setForm.longitude) {
        let coord = [Number(this.setForm.longitude), Number(this.setForm.latitude)];
        this.$refs.refAppMap.setMapCenter(coord);
        this.getLocationCB(coord); //h回显已配置的点位
      } else {
        this.$refs.refAppMap.setMapCenter();
      }
    },
    getLocationCB(event) {
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: [event[0], event[1]],
          src: "images/theme/newDark/map/resource/position_red.png",
          anchor: [10, 20],
        },
      ];
      this.point = [event[0], event[1]];
      this.$refs.refAppMap.removePoint("devicePointId");
      this.$refs.refAppMap.addMarket(option, "devicePointId");
    },
    openMap() {
      this.showMap = true;
      setTimeout(() => {
        this.initMap();
      }, 200);
    },
    mapClose() {
      this.$map.hideMap2D();
    },
    // 点击地图框中的取消操作
    mapCancelOpt() {
      this.showMap = false;
      this.$map.hideMap2D();
    },
    mapConfirmOpt() {
      this.setForm.longitude = Number(this.point[0]).toFixed(10);
      this.setForm.latitude = Number(this.point[1]).toFixed(10);
      this.showMap = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-container {
  width: 100%;
  height: 100%;
  .position-set {
    position: relative;
  }
  .coord {
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0%;
    min-width: 210px;
    background: rgba(13, 18, 28, 0.7);
    padding: 5px 10px;
    color: #fff;
  }
  .area-title {
    margin: 10px 0 16px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
  }
  :deep .el-tree-node__content {
    height: 32px;
    line-height: 32px;
  }
  .area-search {
    margin: 12px;
  }
  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }
  #map-container {
    height: 550px;
  }
  .flex-container {
    display: flex;
    position: relative;
    .left-tree {
      // width: 45%;
      // float: left;
      // display: inline;
      flex: 1;
      height: 500px;
    }
    .right-img {
      margin-left: 12px;
      flex: 2;

      #building-img {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .canvasMain {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: rgba(128, 128, 128, 0.5);
      .canvasMainT {
        position: absolute;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        canvas {
          position: absolute;
        }
      }
    }
  }
  .buildingDialog-footer {
    margin-top: 30px;
  }
}
</style>
